import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Box, Typography, Button, Grid } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import PauseIcon from "@mui/icons-material/Pause";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import VolumeOffIcon from "@mui/icons-material/VolumeOff";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../../../../Home/Components/Nav";
import Footer from "../../../../Home/Components/Footer";
import Contactus from "../../../../contact/Container/Contactformcon";

/* =========================================================================
   PLACEHOLDER ASSETS
   Replace every URL below with the real Hector Tomahawk EV media (photos /
   videos). The whole page is wired to these constants, so swapping a link
   here updates every place that asset is used.
   ========================================================================= */
const CAR_IMAGE =
  "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/carmodels%2F004-khaki-green-s-black-image-2.webp?alt=media&token=11aa4633-35ab-41ee-8fee-23a13585ea28";

const HERO_VIDEO_URL = "https://mgmotor.scene7.com/is/content/mgmotor/005-tomahawk-ev-bn-vid"; // landscape (desktop)
const HERO_VIDEO_PORTRAIT_URL = "https://mgmotor.scene7.com/is/content/mgmotor/005-tomahawk-ev-bn-vid-portrait"; // portrait (mobile)
const HERO_POSTER_IMG = CAR_IMAGE; // shown before/if the hero video hasn't loaded

const POWER_PANEL_IMG_DESKTOP = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2Fsec-sec-d-1.webp?alt=media&token=b60adec9-cb39-4b6f-98a7-45d28e9af242"; // section 2, left panel (desktop)
const POWER_PANEL_IMG_MOBILE = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2Fsec-sec-m-2.webp?alt=media&token=30738871-0b81-4364-b134-4b77186615d1"; // section 2, top panel (mobile)
const V2H_PANEL_IMG_DESKTOP = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2Fsec-sec-d-2.webp?alt=media&token=05681861-857b-4358-947f-453d6a043b62"; // section 2, right panel (desktop)
const V2H_PANEL_IMG_MOBILE = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2Fsec-sec-m-1.webp?alt=media&token=a9668262-603f-4a50-b069-6589775f34b1"; // section 2, bottom panel (mobile)

const PANEL_CONTENT = {
  power: {
    title: "POWER YOUR JOURNEY",
    desc: "Power compatible devices and appliances directly from your vehicle.",
  },
  v2h: {
    title: "POWER THAT GOES BEYOND",
    desc: "V2H lets you use your vehicle's stored energy to help power your home when you need it.",
  },
};

// Section 3 — color picker: one image per swatch
const COLOR_KHAKI_GREEN_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-khaki-green-image.webp?alt=media&token=69efeff2-0ae5-45c9-8b68-baa6848ab459";
const COLOR_GLACIER_WHITE_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-aurora-silver-image.webp?alt=media&token=e6d3d7c4-b21d-4d98-9de5-797d06123acf";
const COLOR_DEEP_SEA_BLUE_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-celadon-blue-image.webp?alt=media&token=421392ff-c36f-438b-b829-bf5e121ed2fb";
const COLOR_SAGE_GREEN_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-khaki-green-s-black-image.webp?alt=media&token=6fbb05a4-657f-4cf0-9a1e-0e674a52a4f6";
const COLOR_PEARL_WHITE_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F005-pearl-white-image.webp?alt=media&token=f259ec0b-d041-4b98-a2be-a658f843b5e8";
const COLOR_OBSIDIAN_BLACK_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F008-starry-black-image.webp?alt=media&token=73068d9e-7ed9-4160-b2b1-38ab5204184f";

const COLOR_OPTIONS = [
  { name: "Khaki Green", hex: "#75795a", image: COLOR_KHAKI_GREEN_IMG },
  { name: "Aurora Sliver", hex: "#d1d1db", image: COLOR_GLACIER_WHITE_IMG },
  { name: "Celadon Blue", hex: "#042343", image: COLOR_DEEP_SEA_BLUE_IMG },
  { name: "Khaki Green + Mono Black", hex: "#7f927f", image: COLOR_SAGE_GREEN_IMG },
  { name: "Pearl White", hex: "#e3e8e5", image: COLOR_PEARL_WHITE_IMG },
  { name: "Starry Black", hex: "#242020", image: COLOR_OBSIDIAN_BLACK_IMG },
];

// Section 4 — Interior slides
const INTERIOR_SLIDE1_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-interiors-image.webp?alt=media&token=067ea38d-02d2-4120-afd6-cfe0e45b9be5"; 
const INTERIOR_SLIDE2_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-interiors-image.webp?alt=media&token=5959f3ef-ac41-4637-a78e-4f68ee1f35c5"; 
const INTERIOR_SLIDE3_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-interiors-image.webp?alt=media&token=421392ff-c36f-438b-b829-bf5e121ed2fb"; 
const INTERIOR_SLIDE4_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-interiors-image.webp?alt=media&token=6fbb05a4-657f-4cf0-9a1e-0e674a52a4f6"; 

const INTERIOR_SLIDES = [
  {
    image: INTERIOR_SLIDE1_IMG,
    title: "BEST-IN-SEGMENT SPACE",
    desc: "2810 mm wheelbase with 85% usable floor space, more legroom and headroom, and flexible 5 and 7 seating options.",
  },
  {
    image: INTERIOR_SLIDE2_IMG,
    title: "22.3 CM MULTI INFORMATION DISPLAY",
    desc: "Essential driving information, clearly in view.",
  },
  {
    image: INTERIOR_SLIDE3_IMG,
    title: "AMBIENT LIGHTING",
    desc: "256-colour ambient lighting for a personalised cabin mood.",
  },
  {
    image: INTERIOR_SLIDE4_IMG,
    title: "PANORAMIC SUNROOF",
    desc: "An expansive view for every seat in the cabin.",
  },
];

// Section 4 — Exterior slides
const EXTERIOR_SLIDE1_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-exteriors-image.webp?alt=media&token=b1283710-05e6-40e4-9d15-a292b98d2208"; // LED MATRIX HEADLAMPS
const EXTERIOR_SLIDE2_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-exteriors-image.webp?alt=media&token=5959f3ef-ac41-4637-a78e-4f68ee1f35c5"; // 20-INCH ALLOY WHEELS
const EXTERIOR_SLIDE3_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-exteriors-image.webp?alt=media&token=421392ff-c36f-438b-b829-bf5e121ed2fb"; // FLUSH DOOR HANDLES
const EXTERIOR_SLIDE4_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-exteriors-image.webp?alt=media&token=12345678-1234-1234-1234-123456789012"; // ANGULAR LIGHTING

const EXTERIOR_SLIDES = [
  {
    image: EXTERIOR_SLIDE1_IMG,
    title: "BEACON HEADLAMPS",
    desc: "LED Projector headlamps with DRLs, designed to cut through the dark.",
  },
  {
    image: EXTERIOR_SLIDE2_IMG,
    title: "ROTOR ALLOYS",
    desc: "R18 Dual-Tone Precision-Cut Alloy Wheels, inspired by the Tomahawk’s supercharger rotor.",
  },
  {
    image: EXTERIOR_SLIDE3_IMG,
    title: "ILLUMINATED MG LOGO",
    desc: "Adds a distinctive touch to its bold front presence.",
  },
  {
    image: EXTERIOR_SLIDE4_IMG,
    title: "BUMPER AND SIGNATURE TAIL LIGHTS",
    desc: "Dynamic LED Tail Lights set into a sculpted rear bumper for a bold look.",
  }
];

// Section 6 — Connectivity slides
const CONNECT_SLIDE1_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-tech-image.webp?alt=media&token=1ecb0170-e437-4d1b-abac-b56a9896a7bd"; // INDIA'S 1ST GEN AI WITH KARAOKE
const CONNECT_SLIDE2_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-tech-image.webp?alt=media&token=5959f3ef-ac41-4637-a78e-4f68ee1f35c5"; // WIRELESS CHARGING PAD
const CONNECT_SLIDE3_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-tech-image.webp?alt=media&token=421392ff-c36f-438b-b829-bf5e121ed2fb"; // SEAMLESS CONNECTIVITY

const CONNECT_SLIDES = [
  {
    image: CONNECT_SLIDE1_IMG,
    title: "INDIA'S 1ST GEN AI WITH KARAOKE",
    desc: "39.6 cm Grand View Display with Gen AI and Karaoke, featuring 8K+ songs across genres.",
  },
  {
    image: CONNECT_SLIDE2_IMG,
    title: "WIRELESS CHARGING PAD",
    desc: "Wireless charging with Android Auto & Apple CarPlay connectivity.",
  },
  {
    image: CONNECT_SLIDE3_IMG,
    title: "SEAMLESS CONNECTIVITY",
    desc: "Stay connected on the move with next-gen infotainment integration.",
  },
];

// Section 8 — Smart mode slides
const SMART_MODE_SLIDE1_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F001-petmode-image.webp?alt=media&token=967e062e-5752-475c-b65d-5e2c29ef35ca"; // PET MODE
const SMART_MODE_SLIDE2_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F002-valetmode-image.webp?alt=media&token=5959f3ef-ac41-4637-a78e-4f68ee1f35c5"; // VALET MODE
const SMART_MODE_SLIDE3_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F003-campmode-image.webp?alt=media&token=421392ff-c36f-438b-b829-bf5e121ed2fb"; // CAMP MODE
const SMART_MODE_SLIDE4_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-energisemode-image.webp?alt=media&token=1ecb0170-e437-4d1b-abac-b56a9896a7bd"; // ENERGISE MODE

const SMART_MODE_SLIDES = [
  {
    image: SMART_MODE_SLIDE1_IMG,
    title: "PET MODE",
    desc: 'Maintains your preferred cabin temperature and displays a "return soon" message.',
  },
  {
    image: SMART_MODE_SLIDE2_IMG,
    title: "VALET MODE",
    desc: "Protects personal data with a custom PIN and provides a detailed trip summary.",
  },
  {
    image: SMART_MODE_SLIDE3_IMG,
    title: "CAMP MODE",
    desc: "Configures the cabin for outdoor adventures and powers compatible camping equipment.",
  },
  {
    image: SMART_MODE_SLIDE4_IMG,
    title: "ENERGISE MODE",
    desc: "Maximises the fan and minimises the temperature for five minutes to cool the cabin quickly.",
  },
];

const SECTION5_VIDEO_URL = "https://mgmotor.scene7.com/is/content/mgmotor/002-feature-video"; // "Space That Gives You More" background video
const SECTION5_IMG = CAR_IMAGE; // fallback image if SECTION5_VIDEO_URL is empty

const SECTION7_VIDEO_URL = "https://mgmotor.scene7.com/is/content/mgmotor/001-battery-video"; // "MAGIC Battery" chassis video
const SECTION7_IMG = CAR_IMAGE; // fallback image if SECTION7_VIDEO_URL is empty

const CALLBACK_BANNER_IMG = "https://firebasestorage.googleapis.com/v0/b/mgcentral-a28cf.firebasestorage.app/o/hector-tomahawk%2F004-hw-kmi-bn-dsc.webp?alt=media&token=6ec05ade-2f96-48c4-9a40-41da0a58a58c"; // "Request a Callback" section banner

// Section 10 — gallery mosaic (7 tiles) — reuses the Interior/Exterior/Smart Mode images
const GALLERY_IMAGE1 = INTERIOR_SLIDE1_IMG;
const GALLERY_IMAGE2 = INTERIOR_SLIDE2_IMG;
const GALLERY_IMAGE3 = INTERIOR_SLIDE3_IMG;
const GALLERY_IMAGE4 = EXTERIOR_SLIDE1_IMG;
const GALLERY_IMAGE5 = EXTERIOR_SLIDE2_IMG;
const GALLERY_IMAGE6 = SMART_MODE_SLIDE1_IMG;
const GALLERY_IMAGE7 = SMART_MODE_SLIDE2_IMG;

const GALLERY_IMAGES = [
  GALLERY_IMAGE1,
  GALLERY_IMAGE2,
  GALLERY_IMAGE3,
  GALLERY_IMAGE4,
  GALLERY_IMAGE5,
  GALLERY_IMAGE6,
  GALLERY_IMAGE7,
];
/* ========================================================================= */

const sectionHeading = {
  fontFamily: "'Poppins', Arial, sans-serif",
  fontWeight: 600,
  textAlign: "center",
  fontSize: { xs: "24px", md: "34px" },
  color: "#111",
};

const sectionSubtext = {
  textAlign: "center",
  color: "#555",
  fontSize: { xs: "13px", md: "15px" },
  maxWidth: "620px",
  margin: "10px auto 0",
};

/* Custom pill-style dots to match the MG official carousel look */
const featureDotsCSS = `
.feature-slider .slick-slide,
.feature-slider .slick-slide div,
.feature-slider .slick-slide:focus,
.feature-slider .slick-track,
.feature-slider .slick-list {
  outline: none;
}
`;

/* Reusable feature-card slider used by sections 4, 6 and 8 */
class FeatureSlider extends Component {
  constructor(props) {
    super(props);
    this.state = { current: 0 };
    this.sliderRef = React.createRef();
  }

  render() {
    const { slides } = this.props;
    const { current } = this.state;
    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 2.3,
      slidesToScroll: 1,
      beforeChange: (_, next) => this.setState({ current: next }),
      responsive: [
        { breakpoint: 900, settings: { slidesToShow: 1.1, infinite: false } },
      ],
    };
    return (
      <Box sx={{ width: "100%", margin: "30px auto 0", px: 0, position: "relative" }} className="feature-slider">
        <style>{featureDotsCSS}</style>
        <Slider ref={this.sliderRef} {...settings}>
          {slides.map((s, i) => (
            <Box key={i} sx={{ px: 1 }}>
              <Box
                component="img"
                src={s.image}
                alt={s.title}
                loading="lazy"
                decoding="async"
                sx={{
                  width: "100%",
                  height: { xs: "180px", md: "340px" },
                  objectFit: "cover",
                  borderRadius: "4px",
                  backgroundColor: "#eee",
                }}
              />
              <Typography sx={{ fontWeight: 700, fontSize: "16px", mt: 2, letterSpacing: "0.3px" }}>
                {s.title}
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#666", mt: 0.5 }}>{s.desc}</Typography>
            </Box>
          ))}
        </Slider>
        <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px", mt: 2.5 }}>
          {slides.map((_, i) => (
            <Box
              key={i}
              onClick={() => this.sliderRef.current && this.sliderRef.current.slickGoTo(i)}
              sx={{
                width: current === i ? "22px" : "8px",
                height: "8px",
                borderRadius: "5px",
                backgroundColor: current === i ? "#d62e2e" : "#f4c9c8",
                cursor: "pointer",
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </Box>
      </Box>
    );
  }
}

class HectorTomahawkEv extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
    this.splitSectionRef = React.createRef();
    this.powerPanelRef = React.createRef();
    this.v2hPanelRef = React.createRef();
    this.colorImgRef = React.createRef();
    this.state = {
      playing: true,
      muted: true,
      activePanel: "power", // "power" | "v2h"
      selectedColor: COLOR_OPTIONS[0],
      prevColorImage: null, // previous swatch image, kept visible underneath while the new one fades in
      colorFadeIn: true,
      activeTab: "interior", // "interior" | "exterior"
    };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleSplitScroll, { passive: true });
    this.handleSplitScroll();
    // warm the cache so switching swatches never has to wait on a network fetch
    COLOR_OPTIONS.forEach((c) => {
      const img = new Image();
      img.src = c.image;
    });

    // <video poster> has no fetchpriority support, so it often loses the
    // race to other page resources and shows a black frame briefly before
    // the poster paints. A high-priority preload link fixes that.
    this.heroPosterPreloadLink = document.createElement("link");
    this.heroPosterPreloadLink.rel = "preload";
    this.heroPosterPreloadLink.as = "image";
    this.heroPosterPreloadLink.href = HERO_POSTER_IMG;
    this.heroPosterPreloadLink.setAttribute("fetchpriority", "high");
    document.head.appendChild(this.heroPosterPreloadLink);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleSplitScroll);
    if (this.heroPosterPreloadLink) document.head.removeChild(this.heroPosterPreloadLink);
  }

  componentDidUpdate(prevProps, prevState) {
    // cached images can fire "load" before React finishes wiring the handler
    // on the freshly-mounted element, so double-check .complete after paint
    if (!this.state.colorFadeIn && this.colorImgRef.current && this.colorImgRef.current.complete) {
      this.setState({ colorFadeIn: true });
    }
  }

  handleColorSelect = (c) => {
    if (c.name === this.state.selectedColor.name) return;
    this.setState({ prevColorImage: this.state.selectedColor.image, selectedColor: c, colorFadeIn: false });
  };

  /* Same layout as desktop, just stacked vertically on mobile — the split
     between POWER/V2H grows and shrinks continuously as the section scrolls
     through the viewport (no tap needed). The active panel opens up to
     nearly the full screen (88%) so its image reads as complete, while the
     other shrinks to a thin sliver (12%) instead of disappearing entirely.
     Desktop keeps the 70/30 click-to-expand behaviour. */
  handleSplitScroll = () => {
    const wrapper = this.splitSectionRef.current;
    const powerEl = this.powerPanelRef.current;
    const v2hEl = this.v2hPanelRef.current;
    if (!wrapper || !powerEl || !v2hEl) return;

    if (window.innerWidth >= 768) {
      powerEl.style.flexBasis = "";
      v2hEl.style.flexBasis = "";
      return;
    }

    const rect = wrapper.getBoundingClientRect();
    const progress = Math.min(1, Math.max(0, (window.innerHeight / 2 - rect.top) / rect.height));

    const powerBasis = 88 - progress * 76; // 88% -> 12%
    const v2hBasis = 12 + progress * 76; // 12% -> 88%
    powerEl.style.flexBasis = `${powerBasis}%`;
    v2hEl.style.flexBasis = `${v2hBasis}%`;

    const next = progress < 0.5 ? "power" : "v2h";
    if (next !== this.state.activePanel) this.setState({ activePanel: next });
  };

  togglePlay = () => {
    const video = this.videoRef.current;
    if (!video) return;
    if (this.state.playing) video.pause();
    else video.play();
    this.setState((prev) => ({ playing: !prev.playing }));
  };

  toggleMute = () => {
    const video = this.videoRef.current;
    this.setState((prev) => {
      if (video) video.muted = !prev.muted;
      return { muted: !prev.muted };
    });
  };

  render() {
    const { activePanel, selectedColor, prevColorImage, colorFadeIn, activeTab } = this.state;

    return (
      <div id="container">
        <Navbar />

        {/* ================= 1. HERO VIDEO SECTION ================= */}
        <Box sx={{ position: "relative", width: "100%", height: "100vh", backgroundColor: "#000", overflow: "hidden" }}>
          {HERO_VIDEO_URL ? (
            <video
              ref={this.videoRef}
              autoPlay
              muted
              loop
              playsInline
              poster={HERO_POSTER_IMG}
              style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
            >
              <source src={HERO_VIDEO_PORTRAIT_URL} media="(max-width: 767px)" type="video/mp4" />
              <source src={HERO_VIDEO_URL} type="video/mp4" />
            </video>
          ) : (
            <Box component="img" src={HERO_POSTER_IMG} alt="Hector Tomahawk EV" loading="eager" fetchpriority="high" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          )}

          {/* Bottom-left: play/mute controls + CTA buttons */}
          <Box
            sx={{
              position: "absolute",
              left: { xs: "16px", md: "40px" },
              right: { xs: "16px", md: "auto" },
              bottom: { xs: "16px", md: "40px" },
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: { xs: "8px", md: "12px" },
            }}
          >
            <Box sx={{ display: "flex", gap: "8px" }}>
              <Box
                onClick={this.togglePlay}
                sx={{ width: "34px", height: "34px", borderRadius: "50%", backgroundColor: "rgba(0,0,0,0.55)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}
              >
                {this.state.playing ? <PauseIcon fontSize="small" /> : <PlayArrowIcon fontSize="small" />}
              </Box>
              <Box
                onClick={this.toggleMute}
                sx={{ width: "34px", height: "34px", borderRadius: "50%", backgroundColor: "rgba(0,0,0,0.55)", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}
              >
                {this.state.muted ? <VolumeOffIcon fontSize="small" /> : <VolumeUpIcon fontSize="small" />}
              </Box>
            </Box>

            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Link to="/connect" style={{ textDecoration: "none" }}>
                <Button
                  variant="outlined"
                  sx={{
                    backgroundColor: "#fff",
                    color: "#111",
                    borderColor: "#fff",
                    fontWeight: 600,
                    borderRadius: "2px",
                    px: 2.5,
                    "&:hover": { backgroundColor: "#eee", borderColor: "#eee" },
                  }}
                >
                  BOOK TEST DRIVE
                </Button>
              </Link>
            </Box>
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Link to="/connect" style={{ textDecoration: "none" }}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "#794F36",
                    fontWeight: 600,
                    borderRadius: "2px",
                    px: 2.5,
                    "&:hover": { backgroundColor: "#5c3a26" },
                  }}
                >
                  BOOK NOW
                </Button>
              </Link>
            </Box>
          </Box>
        </Box>

        {/* Breadcrumb */}
        <Box sx={{ height: "40px", mt: 1, ml: { xs: "16px", md: "50px" } }}>
          <Link to="/" style={{ textDecoration: "none", color: "grey" }}>
            <b>Home</b>
          </Link>
          <Link to="/HectorTomahawkEv" style={{ textDecoration: "none", color: "grey" }}>
            &nbsp;&nbsp;MG Hector Tomahawk EV
          </Link>
        </Box>

        {/* ================= 2. POWER / V2H SPLIT SECTION ================= */}
        <Box
          ref={this.splitSectionRef}
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, width: "100%", height: { xs: "100vh", md: "80vh" }, position: "relative" }}
        >
          {[
            { key: "power", label: "POWER", imgDesktop: POWER_PANEL_IMG_DESKTOP, imgMobile: POWER_PANEL_IMG_MOBILE, ref: this.powerPanelRef },
            { key: "v2h", label: "V2H", imgDesktop: V2H_PANEL_IMG_DESKTOP, imgMobile: V2H_PANEL_IMG_MOBILE, ref: this.v2hPanelRef },
          ].map((panel) => (
            <Box
              key={panel.key}
              ref={panel.ref}
              onClick={() => {
                if (window.innerWidth >= 768) this.setState({ activePanel: panel.key });
              }}
              sx={{
                position: "relative",
                width: { xs: "100%", md: "auto" },
                cursor: { xs: "default", md: "pointer" },
                overflow: "hidden",
                transition: { xs: "none", md: "flex-basis 0.5s ease" },
                flex: activePanel === panel.key ? { xs: "1 1 88%", md: "1 1 70%" } : { xs: "1 1 12%", md: "1 1 30%" },
                borderLeft: { xs: "none", md: panel.key === "v2h" ? "2px solid #fff" : "none" },
                borderTop: { xs: panel.key === "v2h" ? "2px solid #fff" : "none", md: "none" },
              }}
            >
              <Box
                component="img"
                src={panel.imgMobile}
                alt={panel.label}
                loading="eager"
                decoding="async"
                fetchpriority="high"
                sx={{ width: "100%", height: "100%", objectFit: "cover", display: { xs: "block", md: "none" } }}
              />
              <Box
                component="img"
                src={panel.imgDesktop}
                alt={panel.label}
                loading="eager"
                decoding="async"
                fetchpriority="high"
                sx={{ width: "100%", height: "100%", objectFit: "cover", display: { xs: "none", md: "block" } }}
              />
              <Typography sx={{ position: "absolute", top: "24px", left: "24px", color: "#fff", fontWeight: 700, letterSpacing: "1px", fontSize: "16px" }}>
                {panel.label}
              </Typography>

              {activePanel === panel.key && (
                <Box sx={{ position: "absolute", left: { xs: "16px", md: "40px" }, bottom: { xs: "16px", md: "40px" }, right: { xs: "16px", md: "auto" }, color: "#fff", maxWidth: "480px" }}>
                  <Typography sx={{ fontWeight: 700, fontSize: { xs: "22px", md: "32px" } }}>
                    {PANEL_CONTENT[panel.key].title}
                  </Typography>
                  <Typography sx={{ fontSize: { xs: "13px", md: "15px" }, mt: 1 }}>
                    {PANEL_CONTENT[panel.key].desc}
                  </Typography>
                </Box>
              )}
            </Box>
          ))}
        </Box>

        {/* ================= 3. COLOR PICKER SECTION ================= */}
        <Box sx={{ backgroundColor: selectedColor.hex, transition: "background-color 0.4s ease", py: { xs: 4, md: 6 }, textAlign: "center" }}>
          <Typography sx={{ color: "#fff", fontSize: { xs: "20px", md: "28px" }, fontWeight: 500 }}>Your Color Your Style</Typography>
          <Box
            sx={{
              position: "relative",
              width: { xs: "90%", md: "55%" },
              maxWidth: "700px",
              aspectRatio: "16 / 10",
              mx: "auto",
              mt: { xs: 2, md: 4 },
            }}
          >
            {/* previous swatch stays visible underneath so the car is never
                gone while the new image loads/fades in — no blank flash.
                The wrapper's fixed aspect-ratio keeps both layers the same
                size regardless of which image has actually loaded. */}
            {prevColorImage && prevColorImage !== selectedColor.image && (
              <Box
                component="img"
                src={prevColorImage}
                alt=""
                sx={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain", display: "block", zIndex: 1 }}
              />
            )}
            <Box
              key={selectedColor.name}
              ref={this.colorImgRef}
              component="img"
              src={selectedColor.image}
              alt={selectedColor.name}
              decoding="async"
              onLoad={() => this.setState({ colorFadeIn: true })}
              sx={{
                position: "absolute",
                inset: 0,
                zIndex: 2,
                display: "block",
                width: "100%",
                height: "100%",
                objectFit: "contain",
                opacity: colorFadeIn ? 1 : 0,
                transition: "opacity 0.4s ease",
              }}
            />
          </Box>

          <Box sx={{ display: "inline-flex", gap: "10px", backgroundColor: "#fff", borderRadius: "40px", p: "10px 14px", mt: 2 }}>
            {COLOR_OPTIONS.map((c) => (
              <Box
                key={c.name}
                onClick={() => this.handleColorSelect(c)}
                sx={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  backgroundColor: c.hex,
                  cursor: "pointer",
                  border: selectedColor.name === c.name ? "2px solid #111" : "2px solid transparent",
                  boxShadow: "inset 0 0 0 2px #fff",
                }}
              />
            ))}
          </Box>
          <Typography sx={{ color: "#fff", mt: 1.5, fontSize: "15px" }}>{selectedColor.name}</Typography>
        </Box>

        {/* ================= 4. INTERIOR / EXTERIOR SLIDER ================= */}
        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Typography sx={sectionHeading}>Electric Vehicle Designed for Every Journey</Typography>
          <Box sx={{ display: "flex", justifyContent: "center", gap: "8px", mt: 2 }}>
            {["interior", "exterior"].map((tab) => (
              <Box
                key={tab}
                onClick={() => this.setState({ activeTab: tab })}
                sx={{
                  px: 3,
                  py: 0.7,
                  borderRadius: "20px",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                  textTransform: "capitalize",
                  backgroundColor: activeTab === tab ? "#111" : "transparent",
                  color: activeTab === tab ? "#fff" : "#888",
                }}
              >
                {tab}
              </Box>
            ))}
          </Box>
          <FeatureSlider slides={activeTab === "interior" ? INTERIOR_SLIDES : EXTERIOR_SLIDES} />
        </Box>

        {/* ================= 5. SPACE / BACKGROUND VIDEO SECTION ================= */}
        <Box sx={{ position: "relative", width: "100%", height: { xs: "60vh", md: "90vh" }, backgroundColor: "#000", overflow: "hidden" }}>
          {SECTION5_VIDEO_URL ? (
            <video autoPlay muted loop playsInline poster={SECTION5_IMG} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}>
              <source src={SECTION5_VIDEO_URL} type="video/mp4" />
            </video>
          ) : (
            <Box component="img" src={SECTION5_IMG} alt="Space that gives you more" loading="lazy" decoding="async" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          )}

          <Typography
            sx={{
              position: "absolute",
              top: { xs: "24px", md: "48px" },
              left: { xs: "16px", md: "56px" },
              color: "#fff",
              fontWeight: 500,
              fontSize: { xs: "26px", md: "40px" },
              maxWidth: "480px",
            }}
          >
            Space That Gives You More
          </Typography>

          <Box
            sx={{
              position: "absolute",
              left: 0,
              right: 0,
              bottom: { xs: "16px", md: "32px" },
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: { xs: 2, md: 5 },
              flexWrap: "wrap",
            }}
          >
            {["281 cm Wheelbase", "85% Usable Floor Area", "5 & 7-Seater Flexibility"].map((t, i, arr) => (
              <React.Fragment key={t}>
                <Typography sx={{ fontSize: { xs: "12px", md: "15px" }, color: "#fff", fontWeight: 500 }}>{t}</Typography>
                {i < arr.length - 1 && <Box sx={{ width: "1px", height: "16px", backgroundColor: "rgba(255,255,255,0.5)" }} />}
              </React.Fragment>
            ))}
          </Box>
        </Box>

        {/* ================= 6. CONNECTIVITY SLIDER ================= */}
        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Typography sx={sectionHeading}>
            Intelligence and Connectivity
            <br />
            the Future, At Your Fingertips
          </Typography>
          <Typography sx={sectionSubtext}>Comfort, space and smart features designed around everyday living.</Typography>
          <FeatureSlider slides={CONNECT_SLIDES} />
        </Box>

        {/* ================= 7. MAGIC BATTERY SECTION ================= */}
        <Box sx={{ py: { xs: 3, md: 5 }, px: { xs: 2, md: 6 } }}>
          <Grid container spacing={2} alignItems="flex-start">
            <Grid item xs={12} md={5}>
              <Typography sx={{ fontSize: { xs: "24px", md: "32px" }, fontWeight: 600 }}>MAGIC Battery</Typography>
              <Typography sx={{ fontSize: "14px", color: "#555", mt: 1 }}>23 cm ground clearance for added battery protection.</Typography>
            </Grid>
            <Grid item xs={6} md={3.5}>
              <Typography sx={{ fontSize: "13px", color: "#555" }}>2,000+ bench tests and 490+ vehicle validations.</Typography>
              <Typography sx={{ fontWeight: 700, fontSize: "14px", mt: 1 }}>TESTED TO PERFORM</Typography>
            </Grid>
            <Grid item xs={6} md={3.5}>
              <Typography sx={{ fontSize: "13px", color: "#555" }}>Tested to perform in challenging conditions.</Typography>
              <Typography sx={{ fontWeight: 700, fontSize: "14px", mt: 1 }}>EXTREME READY</Typography>
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ width: "100%", height: { xs: "35vh", md: "60vh" }, backgroundColor: "#e8e8e8" }}>
          {SECTION7_VIDEO_URL ? (
            <video autoPlay muted loop playsInline poster={SECTION7_IMG} style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}>
              <source src={SECTION7_VIDEO_URL} type="video/mp4" />
            </video>
          ) : (
            <Box component="img" src={SECTION7_IMG} alt="MAGIC Battery" loading="lazy" decoding="async" sx={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }} />
          )}
        </Box>

        {/* ================= 8. SMART MODES SLIDER ================= */}
        <Box sx={{ py: { xs: 4, md: 6 } }}>
          <Typography sx={sectionHeading}>Smart Modes for Every Moment.</Typography>
          <Typography sx={sectionSubtext}>
            Personalised cabin experiences designed to make every journey more comfortable, convenient and connected.
          </Typography>
          <FeatureSlider slides={SMART_MODE_SLIDES} />
        </Box>

        {/* ================= 9. REQUEST A CALLBACK ================= */}
        <Box sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, md: 6 } }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              <Contactus someValue="Hector Tomahawk EV" />
            </Grid>
            <Grid item xs={12} md={6}>
              <Box component="img" src={CALLBACK_BANNER_IMG} alt="Hector Tomahawk EV" loading="lazy" decoding="async" sx={{ width: "100%", borderRadius: "4px", display: "block" }} />
            </Grid>
          </Grid>
        </Box>

        {/* ================= 10. GALLERY MOSAIC ================= */}
        <Box sx={{ py: { xs: 4, md: 6 }, px: { xs: 2, md: 6 } }}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={4}>
              <Typography sx={{ fontSize: { xs: "26px", md: "34px" }, fontWeight: 600 }}>Every Journey, Your Way</Typography>
              <Typography sx={{ fontSize: "14px", color: "#555", mt: 2 }}>
                Designed to bring comfort, technology and adventure together, wherever the road takes you.
              </Typography>
            </Grid>
            <Grid item xs={12} md={8}>
              <Box sx={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gridAutoRows: { xs: "90px", md: "140px" }, gap: "10px" }}>
                {GALLERY_IMAGES.map((img, i) => {
                  {/* explicit placement so all 3 columns end up exactly the
                      same total height — no leftover empty cells */}
                  const layout = [
                    { gridColumn: "1", gridRow: "1 / span 2" },
                    { gridColumn: "1", gridRow: "3 / span 2" },
                    { gridColumn: "2", gridRow: "1 / span 2" },
                    { gridColumn: "2", gridRow: "3 / span 2" },
                    { gridColumn: "3", gridRow: "1 / span 1" },
                    { gridColumn: "3", gridRow: "2 / span 1" },
                    { gridColumn: "3", gridRow: "3 / span 2" },
                  ];
                  const pos = layout[i] || {};
                  return (
                    <Box
                      key={i}
                      component="img"
                      src={img}
                      alt={`Hector Tomahawk EV ${i + 1}`}
                      loading="lazy"
                      decoding="async"
                      sx={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "2px", ...pos }}
                    />
                  );
                })}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Footer />
      </div>
    );
  }
}

export default HectorTomahawkEv;
